import React from "react";

const MapSection = () => {
  return (
    <section className="w-full  mt-[-120px] z-[999] relative">
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="w-full h-[300px] md:h-[400px] lg:h-[709px] rounded-[30px] overflow-hidden">
          <iframe
            src="https://www.google.com/maps/embed?pb=..." // अपनी सही Map Embed URL यहाँ डालें
            title="Utpann Production Location Map"
            className="w-full h-full border-0"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default MapSection;
